/*
 * Angel Ruche shared wishlist engine (site-wide).
 * - Hearts on product cards (.card-product) + product page (below ATC).
 * - Header wishlist icon next to the cart, with count; visible on all
 *   breakpoints, and hidden entirely while the wishlist is empty.
 * - No floating button and no toast: the header icon is the only indicator,
 *   so nothing overlaps the loyalty / rewards widget.
 * Storage: localStorage ar_wishlist.
 */
(function () {
  var WL_KEY = 'ar_wishlist';

  function getWL() { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e) { return []; } }
  function setWL(a) { try { localStorage.setItem(WL_KEY, JSON.stringify(a)); } catch (e) {} }
  function indexOfHandle(wl, h) { for (var i = 0; i < wl.length; i++) { if (wl[i].handle === h) return i; } return -1; }
  function handleFromUrl(u) { if (!u) return ''; var p = u.split('/products/')[1]; if (!p) return ''; return p.split('?')[0].split('#')[0].split('/')[0]; }

  // Filled heart so it reads as bold/solid like the theme's other header icons.
  var HEART_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';

  function updateCounts() {
    var n = getWL().length;
    var hc = document.getElementById('ar-wl-head-cnt');
    if (hc) { hc.textContent = n > 0 ? n : ''; hc.style.display = n > 0 ? 'block' : 'none'; }
    // Hide the header icon completely while the wishlist is empty.
    var item = document.querySelector('.header__utils-item--wishlist');
    if (item) item.style.display = n > 0 ? '' : 'none';
  }

  function initGlobal() {
    if (window.AR_WL) return;
    window.AR_WL = {
      get: getWL,
      update: updateCounts,
      // Kept as a no-op so any other code calling AR_WL.toast() stays safe.
      toast: function () {}
    };
    updateCounts();
  }

  function paint(btn, active) {
    if (btn.classList.contains('ar-wl-pdp')) {
      btn.classList.toggle('ar-heart--active', active);
      var lbl = btn.querySelector('.ar-wl-pdp__label');
      if (lbl) lbl.textContent = active ? 'In your wishlist' : 'Add to Wishlist';
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    } else {
      btn.innerHTML = active ? '&#9829;' : '&#9825;';
      btn.classList.toggle('ar-heart--active', active);
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    }
  }

  function markAll() {
    var wl = getWL();
    var btns = document.querySelectorAll('[data-wl]');
    for (var i = 0; i < btns.length; i++) {
      paint(btns[i], indexOfHandle(wl, btns[i].getAttribute('data-wl')) > -1);
    }
  }

  function injectCardHearts() {
    var cards = document.querySelectorAll('.card-product');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var main = card.querySelector('.card-product__main');
      if (!main || main.querySelector('.ar-heart')) continue;
      var titleEl = card.querySelector('.card-product__title a, .card-product__title');
      var url = (titleEl && titleEl.getAttribute && titleEl.getAttribute('href')) || card.getAttribute('data-product-url') || '';
      var handle = handleFromUrl(url);
      if (!handle) continue;
      var imgEl = card.querySelector('.card-product__media img');
      var img = imgEl ? (imgEl.getAttribute('data-src') || imgEl.currentSrc || imgEl.src || '') : '';
      if (img && img.indexOf('{width}') > -1) img = img.replace('{width}', '500');
      var priceEl = card.querySelector('.card-product__price');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ar-heart';
      btn.setAttribute('data-wl', handle);
      btn.setAttribute('data-title', titleEl ? titleEl.textContent.trim() : '');
      btn.setAttribute('data-url', url);
      btn.setAttribute('data-img', img);
      btn.setAttribute('data-price', priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '');
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.innerHTML = '&#9825;';
      main.appendChild(btn);
    }
  }

  function injectPdpButton() {
    if (location.pathname.indexOf('/products/') === -1) return;
    if (document.querySelector('.ar-wl-pdp')) return;
    var mainSubmit = document.querySelector('.product__submit');
    var anchor = null;
    if (mainSubmit) {
      anchor = mainSubmit.closest('.product-form__buttons, .product__submit-holder, .buy-buttons, .product-form') || mainSubmit.parentNode;
    }
    if (!anchor) return;
    var handle = handleFromUrl(location.pathname);
    if (!handle) return;
    function meta(p) { var el = document.querySelector('meta[property="' + p + '"]'); return el ? el.getAttribute('content') : ''; }
    var title = meta('og:title') || (document.querySelector('h1') ? document.querySelector('h1').textContent.trim() : '');
    var img = meta('og:image');
    var priceEl = document.querySelector('.product__price .price-item--sale, .product__price .price-item--regular, .product__price .price-item, .price-item');
    var price = priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ar-wl-pdp';
    btn.setAttribute('data-wl', handle);
    btn.setAttribute('data-title', title);
    btn.setAttribute('data-url', '/products/' + handle);
    btn.setAttribute('data-img', img);
    btn.setAttribute('data-price', price);
    btn.setAttribute('aria-label', 'Add to wishlist');
    btn.innerHTML = '<span class="ar-wl-pdp__icon">&#9825;</span><span class="ar-wl-pdp__label">Add to Wishlist</span>';
    anchor.parentNode.insertBefore(btn, anchor.nextSibling);
  }

  function injectHeaderIcon() {
    var ul = document.querySelector('.header__utils-items');
    if (!ul || ul.querySelector('.header__utils-item--wishlist')) return;
    var cart = ul.querySelector('.header__utils-item--cart');
    var li = document.createElement('li');
    // No small-hide/medium-hide: the heart sits beside the cart on mobile too.
    li.className = 'header__utils-item header__utils-item--wishlist';
    // Start hidden so an empty wishlist never flashes the icon; updateCounts
    // reveals it as soon as there is at least one saved item.
    li.style.display = 'none';
    li.innerHTML = '<a href="/pages/wishlist" class="header__utils-link full-unstyled-link relative ar-wl-head-link" aria-label="Wishlist">' + HEART_SVG + '<span class="ar-wl-head-cnt" id="ar-wl-head-cnt"></span></a>';
    if (cart) ul.insertBefore(li, cart); else ul.appendChild(li);
    updateCounts();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wl]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var h = btn.getAttribute('data-wl');
    var wl = getWL();
    var idx = indexOfHandle(wl, h);
    var nowActive;
    if (idx > -1) {
      wl.splice(idx, 1); nowActive = false; setWL(wl);
    } else {
      wl.push({
        handle: h,
        title: btn.getAttribute('data-title') || '',
        url: btn.getAttribute('data-url') || ('/products/' + h),
        img: btn.getAttribute('data-img') || '',
        price: btn.getAttribute('data-price') || ''
      });
      nowActive = true; setWL(wl);
    }
    updateCounts();
    var same = document.querySelectorAll('[data-wl]');
    for (var i = 0; i < same.length; i++) {
      if (same[i].getAttribute('data-wl') === h) paint(same[i], nowActive);
    }
  }, false);

  function scan() { injectHeaderIcon(); injectCardHearts(); injectPdpButton(); markAll(); updateCounts(); }

  function boot() {
    initGlobal();
    scan();
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; scan(); }, 250);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
